import { enviarFormularios, getPacoteFormulariosByUUID, getPacoteFormulariosInstitutionByUUID } from 'api/forms/pacote_formularios.api';
import { create } from 'zustand';

interface IFormulario {
    uuid: string;
    status: number;
    name: string;
    formulario: string;
}

interface IFormulariosStore {
    formularios: IFormulario[];
    setFormularios: (formularios: IFormulario[]) => void;
    getFormulariosByUUID: (uuid: string) => Promise<void>;
    getFormulariosByInstitutionUUID: (uuid: string) => Promise<void>;
    enviarFormularios: (uuid: string) => Promise<boolean>;
}

export const useFormulariosStore = create<IFormulariosStore>((set, get) => ({
    formularios: [],
    setFormularios: (formularios) => set({ formularios }),
    getFormulariosByUUID: async (uuid: string) => {
        const response = await getPacoteFormulariosByUUID(uuid);
        console.log('response sds', response);
        const institutionUUID = response.dados.institution_uuid;
        await get().getFormulariosByInstitutionUUID(institutionUUID);
    },
    getFormulariosByInstitutionUUID: async (uuid: string) => {
        const response = await getPacoteFormulariosInstitutionByUUID(uuid);
        set({ formularios: response.dados.formularios as IFormulario[] });
    },
    enviarFormularios: async (uuid: string) => {
        const response = await enviarFormularios(uuid);
        if (response.Status === `OK`) {
            return true;
        } else {
            return false;
        }
    },
}));